export default function FeatureGrid() {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: 'Product Database',
      description: 'Access a comprehensive and organized collection of product listings spanning multiple categories, making discovery straightforward and efficient for every shopper.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Category Organization',
      description: 'Products are logically grouped into clear categories like Shoes, Hoodies, T-Shirts, Jackets, and Bags so you can navigate directly to what interests you.',
    },
    {
      icon: 'ri-search-line',
      title: 'Shopping Research',
      description: 'Make informed decisions with structured research guides, quality comparisons, and verified shopping information across all major spreadsheet platforms.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Information',
      description: 'Every resource is verified for accuracy and relevance. We prioritize trustworthy, up-to-date product data so you can shop with confidence and peace of mind.',
    },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-label tracking-widest uppercase text-primary-600 mb-3">
            / Why Choose Us
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Why Users Choose Hipobuy Spreadsheet
          </h2>
          <p className="text-base text-foreground-600 mt-4 max-w-2xl mx-auto">
            We have built a resource that combines organized product discovery with reliable research tools, all designed to help you find exactly what you are looking for.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}